'use client';

import { useEffect, useState } from 'react';

function getNextMidnight() {
  const now = new Date();
  const next = new Date(now);
  next.setHours(24, 0, 0, 0);
  return next;
}

export function useNextWordCountdown() {
  const [remaining, setRemaining] = useState<number>(() => {
    return getNextMidnight().getTime() - Date.now();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(getNextMidnight().getTime() - Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { hours, minutes, seconds };
}
